'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const MerchantLogoImage = require('../../shared/views/merchants/merchant-logo-image');

function RedemptionHeader({
  merchantId,
  merchantMedia,
  merchantName,
  offerTitle,
  routes,
}) {
  return h(
    '.redemption-header',
    h('.redemption-header-inner', [
      h(
        'a.redemption-header-logo',
        {
          href: routes.redirect.merchant.replace('{merchantId}', merchantId),
          target: '_blank',
          rel: 'noopener',
          'data-bhc': `direct-link:${merchantId}`,
        },
        h(WithI18n, {}, i18n =>
          MerchantLogoImage({
            className: 'redemption-header-logo-image',
            alt: i18n.t('js.modules.shared.LogoAltTextFormat', {
              0: merchantName,
            }),
            data: merchantMedia,
            size: ['w_100,h_100'],
            lazyload: false,
          })
        )
      ),
      h(
        '.redemption-header-title',
        h('span.redemption-header-title-text', offerTitle)
      ),
    ])
  );
}

module.exports = RedemptionHeader;
